import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { ImgCarouselModule } from 'src/app/shared/components/img-carousel/img-carousel.module';
import { NewSwiperUnitModule } from 'src/app/shared/components/new-swiper-unit/new-swiper-unit.module';
import { PaginatorModule } from 'src/app/shared/components/paginator/paginator.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { ToolTipModule } from 'src/app/shared/components/tool-tip/tool-tip.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { LeaderBoardPopupComponent } from './../../shared/components/leader-board-popup/leader-board-popup.component';
import { DailyContestComponent } from './daily-contest/daily-contest.component';
import { LeaderBoardComponent } from './leader-board.component';

@NgModule({
  imports: [
    CommonModule,
    CustomizeFormModule,
    ToolTipModule,
    PipesModule,
    EmptyModule,
    LoadingModule,
    ScrollbarModule,
    PaginatorModule,
    NewSwiperUnitModule,
    PaginatorModule,
    MatTabsModule,
    ImgCarouselModule,
  ],
  declarations: [LeaderBoardComponent, LeaderBoardPopupComponent, DailyContestComponent],
  exports: [LeaderBoardComponent, DailyContestComponent],
})
export class LeaderBoardModule {}
